export const initialValues = {
  commentName: '',
  commentType: '',
  notes: '',
  reminders: '',
  photos: [],
  videos: [],
};
